import UserRoleConstants from '~/constants/user-role-constants';
import type { Fields } from './data/AuthenticationState';

export const isSalesCompanyUser = (state: Fields) => {
  return state.permissionTypes.includes(UserRoleConstants.SALES_COMPANY_USER);
};

export const checkPermission = (haystack: string[], needle: string) => haystack?.includes(needle);
